require 'plugins/pure/pure-min.css'
require 'plugins/icomoon/style.css'
require 'plugins/flexslider/flexslider.css'
require 'plugins/animate.css/animate.min.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'plugins/myfocus/dist/mf-pattern/mF_fancy.css'
require 'styles/common/util.scss'
require 'styles/common/common.scss'
require 'styles/pages/event-question.scss'

require 'script!jquery'
require '../common/form-validation.coffee'
require 'script!ajaxform'
require 'script!flexslider'
require '../common/city.coffee'

browser =
  isIE8: !!navigator.userAgent.match(/MSIE 8.0/)
  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)

###
# 配置轮播图
###
do->
  $carousel  = $('#carousel')
  $carsli = $carousel.find 'li'
  $ban = $('.nav')
  $nav_li = $ban.find 'li'
  $cont = $('.conts')

  ##tabs切换
  $nav_li.on 'click', (evt)->
    evt.preventDefault()
    $me = $(this)
    id = $me.data('id')
    $nav_li.removeClass 'active'
    $ban.find('li:eq('+id+')').addClass 'active'
    $carsli.removeClass 'active'
    $carousel.find('li:eq('+id+')').addClass 'active'
  $cont.on 'click', (evt)->
    evt.preventDefault()
    $me = $(this)
    $conts=$me.parent('li').find('.conts')
    $conts.removeClass 'active'
    $me.addClass 'active'

###
# 提交问题form
###
do->

  $form = $('#form_qs')
  $context = $form.find 'textarea[name="question"]'
  $name = $form.find 'input[name="user_name"]'
  $tel = $form.find 'input[name="mobile"]'

  $context.focus (evt)->
    evt.preventDefault()
    $me = $(this)
    $me.addClass 'active'
    $form.find('.tips').addClass 'active'

  $context.on 'keyup', ->
    $me = $(this)
    max = $me.attr 'maxlength'
    fontLeng = $me.val().length
    can = max - fontLeng
    $form.find('.tips .red').html(can)

  $form.validate
    showErrors: (errorMap, errorList)->
      if errorList.length is 0
        return false

      alert(errorList[0].message) if browser.isIE8

      sweetAlert {
        type: 'error'
        title: errorList[0].message
        allowOutsideClick: true
        confirmButtonText: '确定'
        confirmButtonColor: '#2F86F9'
      }
    submitHandler: (form)->
      if not browser.isIE8
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"

      $(form).ajaxSubmit
        dataType: 'json'
        error: ->
          alert('对不起！出错了,请稍后重试！') if browser.isIE8

          sweetAlert {
            type: 'error'
            title: '对不起！出错了,请稍后重试！'
            allowOutsideClick: true
            confirmButtonText: '确定'
            confirmButtonColor: '#2F86F9'
          }
        success: (res)->
          if res.status is 'success'
            sweetAlert {
              type: 'success'
              title: res.msg[0].info
              allowOutsideClick: true
              confirmButtonText: '确定'
              confirmButtonColor: '#2F86F9'
              timer: 5000
            }
            $context.val('')
            $name.val('')
            $tel.val('')
          else
            alert(res.msg[0].info) if browser.isIE8
            
            sweetAlert {
              type: 'error'
              title: res.msg[0].info
              allowOutsideClick: true
              confirmButtonText: '确定'
              confirmButtonColor: '#2F86F9'
            }

      return false

  $context.rules 'add',
    required: true
    messages:
      required: '问题不能为空'
  
  $name.rules 'add',
    required: true
    messages:
      required: '姓名不能为空'

  $tel.rules 'add',
    required: true
    mobileNum: true
    messages:
      required: '请输入正确的手机号'



/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez23/wwwroot/static/~/coffeelint-loader!./event-question.coffee
 **/